module.exports = {
    "checkbox": "mcdf4deaf6_checkbox"
};